<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">รอพิจารณา</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          class="btn btn-primary shadow-md mr-2"
          :to="{ name: 'memoMyActivitiesForm' }"
          >สร้าง Memo</router-link
        >
      </div>
    </div>

    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form
          id="tabulator-html-filter-form"
          @submit.prevent="onFilter"
          class="xl:flex sm:mr-auto"
        >
          <div class="sm:flex items-center sm:mr-4">
            <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2"
              >Field</label
            >
            <select
              id="tabulator-html-filter-field"
              v-model="filter.field"
              class="form-select w-full sm:w-32 xxl:w-full mt-2 sm:mt-0 sm:w-auto"
            >
              <option
                v-for="opt in filterOption"
                :key="opt.value"
                :value="opt.value"
                >{{ opt.label }}</option
              >
            </select>
          </div>
          <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
            <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2"
              >Value</label
            >
            <input
              id="tabulator-html-filter-value"
              v-model="filter.value"
              type="text"
              class="form-control sm:w-40 xxl:w-full mt-2 sm:mt-0"
              placeholder="Search..."
            />
          </div>
          <div class="mt-2 xl:mt-0">
            <button
              id="tabulator-html-filter-go"
              type="button"
              class="btn btn-primary w-full sm:w-16"
              @click="onFilter"
            >
              Go
            </button>
            <button
              id="tabulator-html-filter-reset"
              type="button"
              class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1"
              @click="onResetFilter"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted, computed } from 'vue'
import Tabulator from 'tabulator-tables'
import { myHeaders } from '@/utils/api'
import store from '../../../store'
import dayjs from 'dayjs'
export default defineComponent({
  setup() {
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'doc_no',
      type: 'like',
      value: ''
    })

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: process.env.VUE_APP_API_URL + '/memo/memo/getMyDocs',
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        pagination: 'remote',
        paginationSize: 10,
        paginationSizeSelector: [10, 20, 30, 40],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          // console.log('res datatable: ', response.data.data)

          if (response.code == 200) {
            // console.log(response.data)
            return response.data
          } else {
            alert.error(response.message)
            return false
          }
        },

        ajaxURLGenerator: (url, headers, params) => {
          // console.log('ajaxURLGenerator: ', params)
          if (params) {
            const urlNew = []
            if (params.sorters.length > 0) {
              urlNew.push(`sortBy=${params.sorters[0].field}`)
              urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
            }
            if (params.page) {
              urlNew.push(`page=${params.page}`)
            }
            if (params.size > 0) {
              urlNew.push(`per_page=${params.size}`)
            }
            if (params.filters.length > 0) {
              urlNew.push(`filterBy=${params.filters[0].field}`)
              urlNew.push(`filter=${params.filters[0].value}`)
            }
            return urlNew.length ? `${url}?${urlNew.join('&')}` : url
          } else {
            return url
          }
        },
        columns: [
          {
            column: 'doc_no',
            title: 'No',
            field: 'doc_no',
            dir: 'asc'
          },
          {
            title: 'เรื่อง',
            field: 'title',
            dir: 'asc'
          },
          {
            title: 'เรียน',
            field: 'to_array',
            // sorters: false,
            headerSort: false,
            formatter: cell => {
              return cell
                .getData()
                .to_array.map(item => {
                  return item.name
                })
                .join(', ')
            }
          },
          {
            title: 'วันที่เอกสาร',
            field: 'doc_date'
          },
          {
            title: 'วันที่สร้าง',
            field: 'create_date',
            align: 'center',
            formatter: cell => {
              return cell.getData().create_date
                ? dayjs(cell.getData().create_date).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            title: 'Manage',
            field: 'id',
            headerSort: false,
            formatter: cell => {
              if (cell.getData().status_code == 'draft') {
                return (
                  '<a href="/memo/myActivities/form/' +
                  cell.getData().id +
                  '/edit" class="btn btn-outline-warning">แก้ไข</a>'
                )
              } else {
                return (
                  '<a href="/memo/myActivities/form/' +
                  cell.getData().id +
                  '/detail" class="btn btn-outline-primary">รายละเอียด</a>'
                )
              }
            }
          }
        ]
      })
    }

    // Filter function
    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'doc_no'
      filter.type = 'like'
      filter.value = ''
      onFilter()
    }

    onMounted(async () => {
      initTabulator()
      store.dispatch('memo/loadFilterOption')
    })
    const filterOption = computed(() => store.state.memo.filterOption)

    return {
      tableRef,
      filter,
      onFilter,
      onResetFilter,
      filterOption
    }
  }
})
</script>
